import * as React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Room } from "@/types/rooms";
import { useTranslation } from "@/context/LanguageContext";

interface Props {
  room: Room;
  onDelete: () => Promise<void> | void;
  children: React.ReactNode;
}

export function RoomDeleteDialog({ room, onDelete, children }: Props) {
  const { isRtl } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await onDelete();
    setLoading(false);
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>

      <AlertDialogContent dir={isRtl ? "rtl" : "ltr"}>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are you sure you want to delete this room?
          </AlertDialogTitle>
          <AlertDialogDescription>
            "{room.name}" will be permanently deleted.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={loading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
